import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaFacebook, FaInstagram, FaTiktok } from "react-icons/fa";
import { db } from "./Firebase";
import { ref, push, onValue } from "firebase/database";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "./Gallery.css";

const Gallery = () => {
  const [testimonials, setTestimonials] = useState([]);
  const [message, setMessage] = useState("");
  const [name, setName] = useState("");
  const [rating, setRating] = useState(0);

  const navigate = useNavigate();

  // Scroll to top & fetch testimonials
  useEffect(() => {
    window.scrollTo(0, 0);

    const testimonialsRef = ref(db, "testimonials");
    onValue(testimonialsRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const loaded = Object.entries(data).map(([id, value]) => ({
          id,
          ...value,
        }));
        setTestimonials(loaded.reverse());
      } else {
        setTestimonials([]);
      }
    });
  }, []);

  const goToNavigation = () => navigate("/navigation");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!name.trim() || !message.trim() || rating === 0) {
      toast.error("Please fill in all fields before submitting!", {
        position: "top-center",
      });
      return;
    }

    try {
      await push(ref(db, "testimonials"), {
        name,
        message,
        rating,
        timestamp: new Date().toISOString(),
      });

      setName("");
      setMessage("");
      setRating(0);

      toast.success("Thank you! Your testimonial has been submitted.", {
        position: "top-center",
      });
    } catch (err) {
      console.error("Error adding testimonial:", err);
      toast.error("Something went wrong. Please try again.", {
        position: "top-center",
      });
    }
  };

  return (
    <div className="gallery-page-wrapper">
      {/* Header */}
      <header className="header-top">
        <div className="header-left">
          <img src="/logo.jpg" alt="Zhufu Logo" className="header-logo" />
        </div>
        <div className="header-right">
          <nav className="nav-links">
            <Link to="/">Home</Link>
            <Link to="/about">About</Link>
            <Link to="/services">Services</Link>
            <Link to="/gallery">Gallery</Link>
            <Link to="/contact">Contact</Link>
          </nav>
          <button className="menu-btn" onClick={goToNavigation}>
            <span className="bar"></span>
            <span className="bar"></span>
            <span className="bar"></span>
          </button>
        </div>
      </header>

      <div className="gallery-container">
        {/* Gallery Section */}
        <section className="gallery-page">
          <h1 className="gallery-title animate-slideInLeft">
            Welcome to our Gallery
          </h1>
          <p className="gallery-subtitle">
            Take a look at some of the amazing moments from our events and
            client experiences — we take pride in every detail and smile we
            create.
          </p>

          {/* 4 Videos in a 2x2 grid */}
<div className="video-grid">
  <video className="grid-video" src="/video1.mp4" autoPlay loop muted playsInline></video>
  <video className="grid-video" src="/video2.mp4" autoPlay loop muted playsInline></video>
  <video className="grid-video" src="/video3.mp4" autoPlay loop muted playsInline></video>
  <video className="grid-video" src="/video4.mp4" autoPlay loop muted playsInline></video>
</div>

          <p className="video-description">
            At Zhufu, we take pride in every moment we work. We bring our best —
            passion, dedication, and attention to detail — to make every event
            and project not just successful, but memorable for our clients.
          </p>

          <div className="image-row">
            <img src="/photos/event1.jpg" alt="gallery1" className="small-image" loading="lazy" />
            <img src="/photos/event2.jpg" alt="gallery2" className="small-image" loading="lazy" />
            <img src="/photos/event3.jpg" alt="gallery3" className="small-image" loading="lazy" />
            <img src="/photos/event4.jpg" alt="gallery4" className="small-image" loading="lazy" />
          </div>

          {/* Testimonials Section */}
          <div className="testimonials-section">
            <h2 className="testimonials-title">What Our Clients Say</h2>
            <div className="testimonials-list">
              {testimonials.length === 0 ? (
                <p className="no-testimonials">No testimonials yet. Be the first!</p>
              ) : (
                testimonials.map((t) => (
                  <div key={t.id} className="testimonial-card">
                    <p className="testimonial-name">{t.name}</p>
                    <div className="testimonial-stars">
                      {[1, 2, 3, 4, 5].map((star) => (
                        <span
                          key={star}
                          className={star <= t.rating ? "star filled" : "star"}
                        >
                          ★
                        </span>
                      ))}
                    </div>
                    <p className="testimonial-message">{t.message}</p>
                  </div>
                ))
              )}
            </div>

            {/* Entry Form */}
            <h2 className="testimonials-title" style={{ marginTop: "50px" }}>
              Client Testimonial
            </h2>
            <form onSubmit={handleSubmit} className="testimonial-form">
              <input
                type="text"
                placeholder="Your Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
              <div className="star-rating">
                {[1, 2, 3, 4, 5].map((star) => (
                  <span
                    key={star}
                    className={star <= rating ? "star filled" : "star"}
                    onClick={() => setRating(star)}
                  >
                    ★
                  </span>
                ))}
              </div>
              <textarea
                placeholder="Write your message..."
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              ></textarea>
              <button type="submit">Submit</button>
            </form>

            <ToastContainer
              position="top-center"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              pauseOnFocusLoss
              draggable
              pauseOnHover
            />
          </div>
        </section>

        {/* Footer */}
        <footer className="footer">
          <div className="footer-container">
            <div className="footer-left">
              <h3>ZHUFU AGENCY</h3>
              <p>
                Welcome to Zhufu Agency, your premier partner for exceptional
                event staffing solutions. We specialize in outsourcing skilled and
                professional waiters, ushers, bartenders, hostesses, registration
                crew, and runners to ensure seamless execution of your events.
              </p>
              <div className="social-icons">
                <a
                  href="https://www.tiktok.com/@zhufuangency?_t=ZS-8z2JfPdP5RX&_r=1"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaTiktok />
                </a>
                <a
                  href="https://www.instagram.com/zhufuagency?igsh=MXJwZDMzdWVpcG9kbg%3D%3D&utm_source=qr"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaInstagram />
                </a>
                <a
                  href="https://www.facebook.com/zhufuagency"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaFacebook />
                </a>
              </div>
            </div>

            <div className="footer-right">
              <h3>QUICK LINKS</h3>
              <ul>
                <li><Link to="/">Home</Link></li>
                <li><Link to="/about">About</Link></li>
                <li><Link to="/services">Services</Link></li>
                <li><Link to="/gallery">Gallery</Link></li>
                <li><Link to="/contact">Contact</Link></li>
              </ul>
            </div>
          </div>

          <div className="footer-bottom">
            <div>
              <h4>CONTACT US</h4>
              <p>Email Us: <a href="mailto:Zhufuagency1@gmail.com">Zhufuagency1@gmail.com</a></p>
              <p>Call Us: <a href="tel:0659966846">065 996 6846</a></p>
            </div>
            <p className="credits">© 2025 Zhufu. All rights reserved.</p>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default Gallery;
